.item:hover:not(.isHighlighted) {
  background-color: var(--gray-lightest);
}

.isHighlighted {
  background-color: var(--gray-light);
}

.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
}
